<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication"><span><i>For our own Noah, lover of the surf</i> … <i>magic voyages and happy landfalls.</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3dedication.vue?0f3eb732